"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.anti-hallucination.disabled': 'Anti-hallucination feature is not available in your current plan.',
};
